/**
 * GA4 Event tracking — flujo Conecta Asociate
 * Todos los eventos se envían al dataLayer para ser capturados por GTM-KZWCJDQJ.
 */

function push(payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

function productName(productId) {
  return String(productId) === '1' ? 'reloj' : 'colgante';
}

const STEP_NAMES = {
  1: 'datos_titular',
  2: 'domicilio',
  3: 'contactos_emergencia',
  4: 'grupo_familiar',
  5: 'envio',
  6: 'resumen_cotizacion',
  7: 'pago',
};

// ---------------------------------------------------------------------------
// Eventos pre-flujo
// ---------------------------------------------------------------------------

/** Disparar al montar la landing /urgconecta */
export function trackPreHomeView() {
  push({ event: 'pre_home_view' });
}

/** Disparar al confirmar la ciudad en /conecta/locations */
export function trackPreLocationSelect(city) {
  push({ event: 'pre_location_select', city });
}

/** Disparar al montar la pantalla de comparación de productos (/conecta/form) */
export function trackPreConoceMasView() {
  push({ event: 'pre_conoce_mas_view' });
}

/** Disparar al seleccionar un producto y abrir el Cotizador */
export function trackPreCotizaView(productId) {
  push({ event: 'pre_cotiza_view', product: productName(productId) });
}

// ---------------------------------------------------------------------------
// Eventos de afiliación
// ---------------------------------------------------------------------------

/** Disparar cuando el usuario hace click en "AFILIATE" en el Cotizador */
export function trackAfiliacionStart({ productId, memberCount, priceTotal }) {
  push({
    event: 'afiliacion_start',
    product: productName(productId),
    member_count: memberCount,
    price_total: priceTotal,
  });
}

/** Disparar cuando cada paso del formulario se vuelve visible */
export function trackStepView(stepNumber, productId) {
  push({
    event: 'afiliacion_step_view',
    step_number: stepNumber,
    step_name: STEP_NAMES[stepNumber] || `step_${stepNumber}`,
    product: productName(productId),
  });
}

/** Disparar cuando el usuario completa y avanza desde cada paso */
export function trackStepComplete(stepNumber, productId) {
  push({
    event: 'afiliacion_step_complete',
    step_number: stepNumber,
    step_name: STEP_NAMES[stepNumber] || `step_${stepNumber}`,
    product: productName(productId),
  });
}

// ---------------------------------------------------------------------------
// Eventos de pago
// ---------------------------------------------------------------------------

/** Disparar cuando el usuario hace click en "AFILIARME" */
export function trackPaymentAttempt(paymentMethod, productId) {
  push({
    event: 'payment_attempt',
    payment_method: paymentMethod || 'credit',
    product: productName(productId),
  });
}

/** Disparar cuando el pago es exitoso */
export function trackPaymentSuccess({ transactionId, revenue, productId, memberCount, coupon }) {
  push({
    event: 'payment_success',
    transaction_id: transactionId,
    revenue,
    currency: 'ARS',
    product: productName(productId),
    member_count: memberCount,
    coupon_code: coupon || '',
  });
}

/** Disparar cuando el pago falla (tarjeta rechazada, error de red, etc.) */
export function trackPaymentFailure(productId) {
  push({
    event: 'payment_failure',
    product: productName(productId),
  });
}

// ---------------------------------------------------------------------------
// Eventos de cierre del flujo
// ---------------------------------------------------------------------------

/** Disparar cuando el usuario abandona el flujo a mitad del proceso */
export function trackAfiliacionAbandono(productId) {
  push({
    event: 'afiliacion_abandono',
    product: productId ? productName(productId) : undefined,
  });
}

/** Disparar con el resultado final del intento de afiliación */
export function trackAfiliacionResultado({ status, transactionId, productId, priceTotal }) {
  push({
    event: 'afiliacion_resultado',
    resultado: status, // 'success' | 'pending' | 'failure'
    transaction_id: transactionId || '',
    product: productName(productId),
    // El purchase de GA4 toma el value de price_total. Si no viaja acá queda el del
    // cotizador, sin cupones ni descuentos, y no coincide con el monto que recibe Meta.
    ...(priceTotal !== undefined && { price_total: priceTotal }),
  });
}
